export const DefaultLocations = {
  US: {
    Type: 'Country',
    CountryCode: 'US',
    ExpandedName: 'United States',
    GeoPoint: {
      Latitude: 39.5036,
      Longitude: -99.0183,
    },
    Id: 190,
  },
};
